module.exports = __webpack_public_path__ + "img/podcast-series.b992645c.jpg";